import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider, Link, Avatar } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import PublicIcon from '@mui/icons-material/Public';
import PolicyIcon from '@mui/icons-material/Policy';
import GavelIcon from '@mui/icons-material/Gavel';

const appInfo = {
  name: 'SMEDCO Mobile',
  description: 'A modern financial services app for SMEs, powered by Mifos.',
  version: '1.0.0',
  website: 'https://smedco.co.zw',
  privacyPolicy: 'https://smedco.co.zw/privacy-policy/',
  licenses: 'https://smedco.co.zw/licenses/',
};

const AboutUs = () => {
  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2 }}>
            <InfoIcon fontSize="large" />
          </Avatar>
          <Typography variant="h5" gutterBottom>{appInfo.name}</Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            {appInfo.description}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Version {appInfo.version}
          </Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <List>
            <ListItem>
              <PublicIcon sx={{ mr: 2 }} color="primary" />
              <ListItemText
                primary={<Link href={appInfo.website} target="_blank" rel="noopener">Official Website</Link>}
                secondary={appInfo.website}
              />
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <PolicyIcon sx={{ mr: 2 }} color="primary" />
              <ListItemText
                primary={<Link href={appInfo.privacyPolicy} target="_blank" rel="noopener">Privacy Policy</Link>}
                secondary={appInfo.privacyPolicy}
              />
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <GavelIcon sx={{ mr: 2 }} color="primary" />
              <ListItemText
                primary={<Link href={appInfo.licenses} target="_blank" rel="noopener">Licenses</Link>}
                secondary={appInfo.licenses}
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AboutUs; 